import { TFunction } from 'i18next';
import * as Yup from 'yup';

export function AddWorkspaceModalSchema(
  t: TFunction<'sidebar/sidebarComponent', undefined>,
) {
  return Yup.object({
    companyName: Yup.string().required(
      t('page.modals.addWorkspace.errors.companyName.requiredError'),
    ),
    companyType: Yup.number()
      .min(1, t('page.modals.addWorkspace.errors.companyType.minError'))
      .required(t('page.modals.addWorkspace.errors.companyType.requiredError')),
    phoneNumber: Yup.string()
      .min(7, t('page.modals.addWorkspace.errors.phoneNumber.minError'))
      .required(t('page.modals.addWorkspace.errors.phoneNumber.requiredError')),
    countryCode: Yup.string().required(
      t('page.modals.addWorkspace.errors.countryCode.requiredError'),
    ),
  });
}
